import Request from '@hotmart-org-ca/request'

import './request'
import LanguageHelper from 'common/helpers/language'

class Service {
  private treatLanguage = (lang: string): string => {
    let language: string = lang

    if (typeof lang === 'string' && lang.length >= 2) {
      language = lang.substring(0, 2).toLocaleLowerCase()
    }

    if (language !== 'pt' && language !== 'en' && language !== 'es' && language !== 'fr') {
      language = 'en'
    }

    return language
  }

  async getLast() {
    const params = {
      projectName: 'HOTMART',
      typeName: 'GDPR',
      language: this.treatLanguage(LanguageHelper.language),
      onlyRequiredTOS: true
    }

    const options = {
      mode: 'cors'
    }

    const response = await Request('get.tos.last', params, options)
    const responseContent = await fetch(response.content, { method: 'GET', mode: 'cors' })
    const responseTos = await responseContent.json()

    return {
      version: response.version,
      tosJson: responseTos
    }
  }
}

export default new Service()
